import { createLucideIcon } from "lucide-react";

export const Cancel = createLucideIcon(
    "Cancel",
    [
        [
            "path",
            {
                d: "M19 4.9999L5 18.9999",
                key: "ks96wr",
            },
        ],
        [
            "path",
            {
                d: "M5 4.9999L19 18.9999",
                key: "1kgtso",
            },
        ],
    ],
);
